










































































































































































import Vue from 'vue';
import _ from 'lodash';
import Sortable from 'sortablejs';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import { ViewpointDao } from "@/api/ViewpointDao";
import ViewpointSelector from '@/components/common/viewpoint-selector.vue';
import ConfirmationDialog from '@/components/common/confirmation-dialog.vue';

let apiDao: ViewpointDao = new ViewpointDao();

export default Vue.extend({

  name: 'FactorViewer',

  components: {
    ViewpointSelector,
    ConfirmationDialog,
  },

  props: {
    sourceViewpointsProp: {
      type: Array,
      default: () => [],
    },
    sourceViewpointIdProp: {
      type: String,
      default: '',
    },
    compareProp: {
      type: Boolean,
      default: false,
    },
    targetViewpointsProp: {
      type: Array,
      default: () => [],
    },
    targetViewpointIdProp: {
      type: String,
      default: '',
    },
    teamProp: {
      type: Object,
      default: () => {},
    },
    authorizedActionsProp: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      viewerCols: 12,
      packageId: this.$store.getters.getPackageId,
      updateAllFactorWeightsDebounce: {} as any,
      compare: this.compareProp,

      sourceLoading: false,
      sourceApiResponse: {} as any,
      sourceViewpoints: this.sourceViewpointsProp,
      sourceViewpointId: this.sourceViewpointIdProp,
      sourceFactorsToUpdate: {} as any,
      sourceError: '',
      sourceItem: {} as any,
      sourceDialog: false,
      sourceDialogRemember: false,
      sourceUpdateKey: 0,
      sourcePage: 1,
      sourceItemsPerPage: -1,

      targetLoading: false,
      targetApiResponse: {} as any,
      targetViewpoints: this.targetViewpointsProp,
      targetViewpointId: this.targetViewpointIdProp,
      targetFactorsToUpdate: {} as any,
      targetError: '',
      targetDialog: false,
      targetDialogRemember: false,
      targetItem: {} as any,
      targetUpdateKey: 0,
      targetPage: 1,
      targetItemsPerPage: -1,

      sourceTargetDiff: {
                          copyItems:   [],
                          sameItems:   [],
                          deleteItems: [],
                        } as any,
      headers:  [
                  // { text: "Factor Weight", value: "weight", sortable: true, width: '250px', align: 'center', },
                  // { text: "Category", value: "name", sortable: true, width: '250px', align: 'center', },
                ],
      hideHeader: true,
      hideFooter: true,
      thumbWidth: 100,
      thumbHeight: 75,
    };
  },

  created() {
    console.log('[ FactorViewer created() ]');
    if (this.sourceViewpointId) {
      this.loadFactors(this.sourceViewpointId, 'source');
    }
    if (this.targetViewpointId) {
      this.loadFactors(this.targetViewpointId, 'target');
    }
    if (this.compare) {
      this.viewerCols = 6;
    }
    this.updateAllFactorWeightsDebounce = _.debounce( () => {
      this.updateAllFactorWeights();
    }, 3000);
  },

  mounted() {
  },

  beforeDestroy() {
    this.updateAllFactorWeightsDebounce.cancel();
  },

  watch: {
    sourceViewpointIdProp(newVal, oldVal) {
      this.sourceViewpointId = newVal;
    },
    sourceViewpointId(newVal, oldVal) {
      if (newVal) {
        this.loadFactors(newVal, 'source');
      } else {
        this.sourceApiResponse = {};
      }
    },
    targetViewpointIdProp(newVal, oldVal) {
      this.targetViewpointId = newVal;
    },
    targetViewpointId(newVal, oldVal) {
      if (newVal) {
        this.loadFactors(newVal, 'target');
      } else {
        this.targetApiResponse = {};
      }
    },
    compareProp(newVal, oldVal) {
      this.compare = newVal;
      this.viewerCols = ( newVal ? 6 : 12 )
    },
    sourceItems(newVal, oldVal) {
      this.setSourceTargetDiff();
    },
    targetItems(newVal, oldVal) {
      this.setSourceTargetDiff();
    },
  },

  computed: {

     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),

    loading(): boolean {
      return (this.sourceLoading || this.targetLoading);
    },

    // Computed Properties may need a Setter for Draggable to rearrange them.
    // Or try storing as data () variable.
    sourceItems(): any[] {
      if (this.sourceApiResponse.hasOwnProperty('factors')) {
        const res: any[] = this.sourceApiResponse.factors.filter( (factor: any) => ( !!factor.weight ) )
        return res;
      } else {
        return [];
      }
    },

    // Computed Properties may need a Setter for Draggable to rearrange them
    // Or try storing as data () variable.
    targetItems(): any[] {
      if (this.targetApiResponse.hasOwnProperty('factors')) {
        const res: any[] = this.targetApiResponse.factors.filter( (factor: any) => ( !!factor.weight ) );
        return res;
      } else {
        return [];
      }
    },

    filteredHeaders(): any[] {
      if (this.compare) {
        return this.headers;
      } else {
        return this.headers.filter( (header: any) => (header.value !== "actions") );
      }
    },

  },

  methods: {

    // Slider onChange callback to track Factor changes and batch the
    // API call by returning a debounce updateAll function
    updateFactorWeight(weight: number, item: any, location: string): any {
      item.weight = weight;
      switch(location) {
        case 'source':
          // Deep cloning in case some other function changes
          // the "item" object in a way that we don't want
          this.sourceFactorsToUpdate[item.id] = _.cloneDeep(item);
          break;
        case 'target':
          this.targetFactorsToUpdate[item.id] = _.cloneDeep(item);
          break;
      }
      // Return the debounce wrapper for updateAllFactorWeights()
      return this.updateAllFactorWeightsDebounce();
    },

    updateAllFactorWeights() {
      console.log('[ updateAllFactorWeights() > this.sourceFactorsToUpdate ]');
      console.log(this.sourceFactorsToUpdate);
      console.log('[ updateAllFactorWeights() > this.targetFactorsToUpdate ]');
      console.log(this.targetFactorsToUpdate);
      if (this.sourceViewpointId) { this.sourceLoading = true; }
      if (this.targetViewpointId) { this.targetLoading = true; }
      // const updateSourceFactorWeights: any = this.updateFactorWeights(this.packageId, this.sourceViewpointId, this.sourceFactorsToUpdate, 'source');
      // const updateTargetFactorWeights: any = this.updateFactorWeights(this.packageId, this.targetViewpointId, this.targetFactorsToUpdate, 'target');
      const updateSourceFactorWeights: any = true;
      const updateTargetFactorWeights: any = true;
      Promise.all([updateSourceFactorWeights, updateTargetFactorWeights])
        .then(
          (response) => {
            console.log('updateAllFactorWeights() RESPONSE:');
            console.log(response);
            this.sourceFactorsToUpdate = {};
            this.targetFactorsToUpdate = {};
          }
        )
        .catch(
          (error) => {
            console.log('updateAllFactorWeights() ERROR: ' + error);
          }
        )
        .finally(
          () => {
            if (this.sourceViewpointId) {
              this.loadFactors(this.sourceViewpointId, 'source');
            }
            if (this.targetViewpointId) {
              this.loadFactors(this.targetViewpointId, 'target');
            }
          }
        );
    },

    async updateFactorWeights(packageId: string, viewpointId: string, factors: any, location: string): Promise<any> {
      if ( Object.keys(factors).length ) {
        for (const factor in factors) {
          factors[factor].weight = factors[factor].weight / 100;
        }
        return apiDao.updateFactorWeights(packageId, viewpointId, factors)
          .then( response => {
            console.log('[ updateFactorWeights() > apiDao.updateFactorWeights > RESPONSE ]: ' + location);
            console.log(response);
          })
          .catch( error => {
            console.log('[ updateFactorWeights() > apiDao.updateFactorWeights > ERROR ]: ' + location);
            console.log(error);
          });
      } else {
        return;
      }
    },

    createDraggableElements(targetHtmlId: string, location: string): any {
      // let table = document.querySelector(".v-data-table tbody");
      var table: any = document.getElementById(targetHtmlId);
      console.log(table)
      var el: any = table.getElementsByTagName('tbody')[0];
      console.log(el)
      const _self: any = this;
      return Sortable.create(el, {
        handle: '.vp--drag-handle', // Use handle so user can select text
        onEnd(evt: any) {
          const rowSelected = ( location == 'source' ? _self.sourceItems.splice(evt.oldIndex, 1)[0] : _self.targetItems.splice(evt.oldIndex, 1)[0]); // Get the selected row and remove it
          ( location == 'source' ? _self.sourceItems.splice(evt.newIndex, 0, rowSelected) : _self.targetItems.splice(evt.newIndex, 0, rowSelected)) // Move it to the new index
        }
      });
    },

    async loadFactors(viewpointId: string, location: string) {
      if (location == 'source') { this.sourceLoading = true; }
      if (location == 'target') { this.targetLoading = true; }
      let res: any = {};
      let err: any = '';
      await apiDao.getFactors(this.packageId, viewpointId)
        .then( response => {
          console.log('[ loadFactors() > apiDao.getFactors > RESPONSE ]: ' + location);
          console.log(response);
          res = response;
        })
        .catch( error => {
          console.log('[ loadFactors() > apiDao.getFactors > ERROR ]: ' + location);
          console.log(error);
          err = error;
        });
      if (Object.keys(res).length) {
        res.factors = _.pickBy(res.factors, (factor: any) => { return factor.groups.includes('FG1')} );
        res.factors = _.orderBy(res.factors, [(factor: any) => { return factor.weight }, (factor: any) => { return factor.name }], ['desc','asc'] );
        console.log(res);
        // TODO: Refactor using _.map as it performs much better (Dion 2020-02-02)
        Object.keys(res.factors).map(function(key, index) {
          res.factors[key].weight *= 100;
        });

      }
      switch(location) {
        case 'source':
          this.sourceApiResponse = res;
          this.sourceError = err;
          break;
        case 'target':
          this.targetApiResponse = res;
          this.targetError = err;
          break;
      }
      // TODO - Need to prevent the same viewpoint viewed from being in the list of Target Viewpoints (Dion 2020-02-06)
      // if (this.targetViewpointId == this.sourceViewpointId) {
      //   this.sourceUpdateKey++;
      //   this.targetUpdateKey++;
      // }
      if (location == 'source') { this.sourceLoading = false; }
      if (location == 'target') { this.targetLoading = false; }
      let _self: any = this;
      
      // Instantiate the draggable behaviour on the Data Table <tbody>'s rows
      if (location =='source' || true) {
        setTimeout(() => { _self.createDraggableElements('factor-'+location+viewpointId, location) }, 500);
      }
    },

    copyItemDialog(item: any) {
      this.sourceItem = item;
      this.sourceDialog = true;
    },

    async copyItem() {
      this.sourceDialog = false;
      this.sourceLoading = true;
      this.targetLoading = true;
      console.log('[ COPY ITEM ]');
      // await apiDao.addFavoriteToViewpoint(this.packageId, this.targetViewpointId, this.sourceItem.id)
      //   .then( response => {
      //     console.log('[ copyItem() > apiDao.addFavoriteToViewpoint > RESPONSE ]');
      //     console.log(response);
      //   })
      //   .catch( error => {
      //     console.log('[ copyItem() > apiDao.addFavoriteToViewpoint > ERROR ]');
      //     console.log(error);
      //   });
      this.loadFactors(this.targetViewpointId, 'target');
      this.loadFactors(this.sourceViewpointId, 'source');
    },

    deleteItemDialog(item: any) {
      this.targetItem = item;
      this.targetDialog = true;
    },

    async deleteItem() {
      this.targetDialog = false;
      this.sourceLoading = true;
      this.targetLoading = true;
      console.log('[ DELETE ITEM ]');
      // await apiDao.removeFavoriteFromViewpoint(this.packageId, this.targetViewpointId, this.targetItem.id)
      //   .then( response => {
      //     console.log('[ deleteItem() > apiDao.removeFavoriteFromViewpoint > RESPONSE ]');
      //     console.log(response);
      //   })
      //   .catch( error => {
      //     console.log('[ deleteItem() > apiDao.removeFavoriteFromViewpoint > ERROR ]');
      //     console.log(error);
      //   });
      this.loadFactors(this.sourceViewpointId, 'source');
      this.loadFactors(this.targetViewpointId, 'target');
    },

    setSourceTargetDiff() {
      if (this.sourceItems.length && this.targetItems.length) {
        const sourceItems: any[] = _.map(this.sourceItems, 'id');
        const targetItems: any[] = _.map(this.targetItems, 'id');
        this.sourceTargetDiff.copyItems   = sourceItems.filter( (item: any) => !targetItems.includes(item) );
        this.sourceTargetDiff.sameItems   = sourceItems.filter( (item: any) =>  targetItems.includes(item) );
        this.sourceTargetDiff.deleteItems = targetItems.filter( (item: any) => !sourceItems.includes(item) );
      } else {
        this.sourceTargetDiff.copyItems.length = 0;
        this.sourceTargetDiff.sameItems.length = 0;
        this.sourceTargetDiff.deleteItems.length = 0;
      }
    },

    isAuthorized(action: string): boolean {
      return this.authorizedActionsProp.includes(action);
    },

    formatPrice(price: any): any {
      const res: any = Number(price).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      return res;
    },

    formatScore(score: number, decimals: number = 1): number {
      // const res: any = Number(Math.round(Number(score+'e'+decimals))+'e-'+decimals)*10;
      const res: any = Math.round(Number(score)*100) / 10;
      return res.toFixed(decimals);
    },

    sourceViewpointSelected(viewpointId: any) {
      console.log('[ viewpointSelected() > sourceViewpointId ]' + viewpointId);
      this.sourceViewpointId = viewpointId;
    },

    targetViewpointSelected(viewpointId: any) {
      console.log('[ viewpointSelected() > targetViewpointId ]' + viewpointId);
      this.targetViewpointId = viewpointId;
    },

    formatNumber(value: number, digits: number = 0) {
      if (digits < 0) digits = 0;
      var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      });
      return Number(formatter.format(value));
    },

  },


});

